"use client";

import { useTranslation } from "react-i18next";

export function PaymentDivider() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center my-6">
      <div className="flex-1 h-px bg-[#DAE0EB]"></div>
      <span className="px-4 text-[#949ABF] text-[10px] font-bold uppercase">
        {t("common.or")}
      </span>
      <div className="flex-1 h-px bg-[#DAE0EB]"></div>
    </div>
  );
}
